module.exports = __webpack_public_path__ + "img/58.7fb4cd58.jpg";